import React from "react";
import { Link } from "react-router-dom";
import { FaBuilding, FaHome, FaStore, FaHotel, FaStar, FaHouseUser } from "react-icons/fa";
import { motion } from "framer-motion";

// Danh mục bất động sản nổi bật
const categoriesData = [
    {
        name: "Căn hộ / Chung cư",
        count: "12,500+",
        icon: FaBuilding,
        link: "/search?propertyType=apartment",
        color: "from-blue-500 to-blue-700",
        desc: "Không gian sống tiện nghi, hiện đại cho gia đình trẻ.",
    },
    {
        name: "Villa / Biệt thự",
        count: "8,200+",
        icon: FaHome,
        link: "/search?propertyType=villa",
        color: "from-green-500 to-green-700",
        desc: "Không gian sang trọng, riêng tư, lý tưởng để nghỉ dưỡng.",
    },
    {
        name: "Shophouse / Nhà phố thương mại",
        count: "5,900+",
        icon: FaStore,
        link: "/search?propertyType=shophouse",
        color: "from-yellow-500 to-yellow-600",
        desc: "Kết hợp kinh doanh và sinh sống tiện lợi.",
    },
    {
        name: "Condotel",
        count: "3,100+",
        icon: FaHotel,
        link: "/search?propertyType=condotel",
        color: "from-purple-500 to-purple-700",
        desc: "Căn hộ khách sạn, đầu tư và nghỉ dưỡng linh hoạt.",
    },
    {
        name: "Penthouse",
        count: "1,800+",
        icon: FaStar,
        link: "/search?propertyType=penthouse",
        color: "from-red-500 to-red-700",
        desc: "Căn hộ cao cấp, sang trọng với tầm nhìn đắt giá.",
    },
    {
        name: "Duplex",
        count: "4,500+",
        icon: FaHouseUser,
        link: "/search?propertyType=duplex",
        color: "from-teal-500 to-teal-700",
        desc: "Thiết kế 2 tầng trong 1 căn hộ, không gian rộng rãi.",
    },
];

// Animation setup
const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default function FeaturedCategories() {
    return (
        <section className="py-20 bg-[#082f49]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Tiêu đề */}
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-14"
                >
                    <h2 className="text-4xl md:text-5xl font-extrabold text-white">
                        Khám phá <span className="text-[#c9a063]">Danh mục nổi bật</span>
                    </h2>
                    <p className="mt-4 text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
                        Nhanh chóng tìm kiếm loại hình bất động sản phù hợp với nhu cầu của bạn.
                    </p>
                </motion.div>

                {/* Grid danh mục */}
                <motion.div
                    className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6"
                    initial="hidden"
                    animate="visible"
                    variants={{
                        visible: { transition: { staggerChildren: 0.1 } },
                    }}
                >
                    {categoriesData.map((category, index) => {
                        const Icon = category.icon;
                        return (
                            <motion.div
                                key={index}
                                variants={cardVariants}
                                whileHover={{
                                    scale: 1.07,
                                    rotate: 1,
                                    transition: { type: "spring", stiffness: 300 },
                                }}
                            >
                                <Link
                                    to={category.link}
                                    className="group block bg-white rounded-2xl shadow-md hover:shadow-2xl p-6 border border-gray-100 hover:border-transparent transition-all duration-300 h-full"
                                >
                                    <div className="relative mb-4">
                                        <div
                                            className={`absolute inset-0 rounded-full blur-xl opacity-25 bg-gradient-to-br ${category.color}`}
                                        ></div>
                                        <div
                                            className={`relative z-10 w-14 h-14 bg-gradient-to-br ${category.color} text-white rounded-full flex items-center justify-center`}
                                        >
                                            <Icon className="w-7 h-7" />
                                        </div>
                                    </div>
                                    <h3 className="text-lg md:text-xl font-bold text-gray-800 group-hover:text-red-600 transition-colors">
                                        {category.name}
                                    </h3>
                                    <p className="text-sm text-gray-500 mt-1 font-semibold">
                                        {category.count} tin đăng
                                    </p>
                                    <p className="mt-2 text-gray-600 text-sm">{category.desc}</p>
                                </Link>
                            </motion.div>
                        );
                    })}
                </motion.div>

                {/* Nút xem thêm */}
                <motion.div
                    className="text-center mt-12"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                >
                    <Link
                        to="/overview"
                        className="inline-block bg-red-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-red-700 transition-all shadow-md hover:shadow-xl"
                    >
                        Xem tất cả danh mục
                    </Link>
                </motion.div>
            </div>
        </section>
    );
}
